import React from "react";
import { connect } from 'react-redux';
import { isNull } from "lodash";

import { PageTitle } from '../PageTitle';
import { Message } from "../Message";
import { TicketsService } from "../../services";
import TicketActivityList from "./ticket_activity_list";
import TicketForm from "./ticket_form";
import i18next from "i18next";

@connect()
class TicketView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ticketId: props.match.params.ticketId,
      redirectTo: props.location.state
          ? props.location.state.history
          : "/monitoring/tickets",
      ticket: null,
      categories: null,
      statuses: null,
      priorties: null,
      taskStatuses: null,
      taskTypes: null,
      activityEnabled: false,
      localErrorMessage: null,
      localSuccessMessage: null
    };
  }

  componentDidMount() {
    this.refreshTicket();

    TicketsService.getAllCategories()
        .then(response => {
          this.setState({ categories: response.categories });
        })
        .catch(error => {
          this.handleLocalError( i18next.t('messages.could-not-load-categories') );
          console.error(error);
        });

    TicketsService.getAllStatuses()
        .then(response => {
          this.setState({ statuses: response.statuses });
        })
        .catch(error => {
          this.handleLocalError( i18next.t('messages.could-not-load-statuses') );
          console.error(error);
        });

    TicketsService.getAllPriorities()
        .then(response => {
          this.setState({ priorties: response.priorties });
        })
        .catch(error => {
          this.handleLocalError( i18next.t('messages.could-not-load-priorities') );
          console.error(error);
        });

    TicketsService.getAllTaskStatuses()
        .then(response => {
          this.setState({ taskStatuses: response.statuses });
        })
        .catch(error => {
          this.handleLocalError( i18next.t('messages.could-not-load-task-statuses') );
          console.error(error);
        });

    TicketsService.getAllTaskTypes()
        .then(response => {
          this.setState({ taskTypes: response.taskTypes });
        })
        .catch(error => {
          this.handleLocalError( i18next.t('messages.could-not-load-task-types') );
          console.error(error);
        });
  }

  refreshTicket() {
    this.setState({ ticket: null });

    TicketsService.get(this.state.ticketId)
        .then(response => {
          this.setState({
            ticket: response.ticket,
            activityEnabled: response.ticket.status.allowActivity
          });
        })
        .catch(error => {
          this.handleLocalError( i18next.t('messages.could-not-load-ticket') );
          console.error(error);
        });
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleLocalSuccess(localSuccessMessage) {
    this.setState({ localSuccessMessage: localSuccessMessage });
  }

  messageDismissCallback() {
    this.setState({
      localErrorMessage: null,
      localSuccessMessage: null
    });
  }

  saveTicket({ description, status, priority, assignedTo, category }) {
    const ticket = {
      id: this.state.ticket.id,
      description: description,
      status: status.status,
      priority: priority.priority,
      category: category.category,
      assignedTo: assignedTo.value ? { id: assignedTo.value } : null
    };

    const existingTicket = this.state.ticket;
    this.setState({ ticket: null });
    TicketsService.save(ticket)
        .then(response => {
          this.setState({
            ticket: response.data,
            activityEnabled: response.data.status.allowActivity,
            localSuccessMessage: i18next.t('messages.ticket-saved-success')
          });
        })
        .catch(error => {
          this.setState({
            ticket: existingTicket,
            localErrorMessage: i18next.t('messages.ticket-saved-failure')
          });
          console.error(error);
        });
  }

  render() {
    const {
      ticket,
      categories,
      statuses,
      priorties,
      taskStatuses,
      taskTypes,
      activityEnabled,
      localErrorMessage,
      localSuccessMessage
    } = this.state;

    if (
        [ticket, categories, statuses, priorties, taskStatuses, taskTypes].some(
            value => isNull(value)
        )
    ) {
      return <div className="loader">{ i18next.t('loading') }</div>;
    }

    let fromLeaf = this.props.location.state ? (this.props.location.state.grouping ? this.props.location.state.grouping : this.props.location.state.fromLeafNode) : null;
    const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
    return (
        <div className="ticket ">
          <div className="row">
            <PageTitle title={ticket.title}
                       backLinkWithParams={{
                         link: {
                           pathname: "/monitoring/tickets",
                           search: backLinkSearch
                         }
                       }}
             />
          </div>

          <Message
              messages={{ state: { successMessage: localSuccessMessage } }}
              errorMessage={localErrorMessage}
              messageDismissCallback={this.messageDismissCallback.bind(this)}
          />
          <div className="op-content-box">
            <TicketForm
                ticket={ticket}
                handleCancel={this.refreshTicket.bind(this)}
                onSubmit={this.saveTicket.bind(this)}
                categories={categories}
                statuses={statuses}
                priorties={priorties}
                grouping = {fromLeaf}
                redirectTo = {this.state.redirectTo}
                history = {`/monitoring/tickets/view/${ticket.id}`}
            />
          </div>
          <div className="op-content-box">
            <TicketActivityList
                ticket={ticket}
                localErrorHandler={this.handleLocalError.bind(this)}
                handleLocalSuccess={this.handleLocalSuccess.bind(this)}
                taskStatuses={taskStatuses}
                taskTypes={taskTypes}
                activityEnabled={activityEnabled}
                refreshTicket={this.refreshTicket.bind(this)}
            />
          </div>
        </div>
    );
  }
}

export default TicketView;
